import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { spacing } = theme;

//TODO: replace with the color tokens after ADS-254
const colors = {
  textOnHighlightRed: '#A31035',
  borderHighlightRed: '#FFE0E7',
  backgroundHighlightRed: '#FFF0F3',

  textOnHighlightOrange: '#8A4300',
  borderHighlightOrange: '#FFE5D6',
  backgroundHighlightOrange: '#FFF2E3',

  textOnHighlightMagenta: '#A30564',
  borderHighlightMagenta: '#FFE3F4',
  backgroundHighlightMagenta: '#FFF0F9',

  textOnHighlightPurple: '#6C37A1',
  borderHighlightPurple: '#F3E6FF',
  backgroundHighlightPurple: '#F8F2FF',

  textOnHighlightBlue: '#005780',
  borderHighlightBlue: '#D1F1FF',
  backgroundHighlightBlue: '#E6F7FF',

  textOnHighlightGreen: '#006131',
  borderHighlightGreen: '#C6F5D6',
  backgroundHighlightGreen: '#DCFCE8',
};

export default createUseStyles(
  {
    root: {
      borderRadius: 28,
      display: 'inline-block',
      padding: [spacing.sp01, spacing.sp02],
    },
    red: {
      color: colors.textOnHighlightRed,
      border: [1, 'solid', colors.borderHighlightRed],
      backgroundColor: colors.backgroundHighlightRed,
    },
    orange: {
      color: colors.textOnHighlightOrange,
      border: [1, 'solid', colors.borderHighlightOrange],
      backgroundColor: colors.backgroundHighlightOrange,
    },

    magenta: {
      color: colors.textOnHighlightMagenta,
      border: [1, 'solid', colors.borderHighlightMagenta],
      backgroundColor: colors.backgroundHighlightMagenta,
    },

    green: {
      color: colors.textOnHighlightGreen,
      border: [1, 'solid', colors.borderHighlightGreen],
      backgroundColor: colors.backgroundHighlightGreen,
    },

    blue: {
      color: colors.textOnHighlightBlue,
      border: [1, 'solid', colors.borderHighlightBlue],
      backgroundColor: colors.backgroundHighlightBlue,
    },

    purple: {
      color: colors.textOnHighlightPurple,
      border: [1, 'solid', colors.borderHighlightPurple],
      backgroundColor: colors.backgroundHighlightPurple,
    },
  },
  {
    name: 'Tag',
  },
);
